import React, {useState} from 'react';
import './form.scss';
const Form = ({thanksModal}) => {
  const countries = ["Afganistán","Albania","Alemania","Andorra","Angola","Antigua y Barbuda","Arabia Saudita","Argelia","Argentina","Armenia","Australia","Austria","Azerbaiyán","Bahamas","Bangladés","Barbados","Baréin","Bélgica","Belice","Benín","Bielorrusia","Birmania","Bolivia","Bosnia y Herzegovina","Botsuana","Brasil","Brunéi","Bulgaria","Burkina Faso","Burundi","Bután","Cabo Verde","Camboya","Camerún","Canadá","Catar","Chad","Chile","China","Chipre","Ciudad del Vaticano","Colombia","Comoras","Corea del Norte","Corea del Sur","Costa de Marfil","Costa Rica","Croacia","Cuba","Dinamarca","Dominica","Ecuador","Egipto","El Salvador","Emiratos Árabes Unidos","Eritrea","Eslovaquia","Eslovenia","España","Estados Unidos","Estonia","Etiopía","Filipinas","Finlandia","Fiyi","Francia","Gabón","Gambia","Georgia","Ghana","Granada","Grecia","Guatemala","Guyana","Guinea","Guinea ecuatorial","Guinea-Bisáu","Haití","Honduras","Hungría","India","Indonesia","Irak","Irán","Irlanda","Islandia","Islas Marshall","Islas Salomón","Israel","Italia","Jamaica","Japón","Jordania","Kazajistán","Kenia","Kirguistán","Kiribati","Kuwait","Laos","Lesoto","Letonia","Líbano","Liberia","Libia","Liechtenstein","Lituania","Luxemburgo","Madagascar","Malasia","Malaui","Maldivas","Malí","Malta","Marruecos","Mauricio","Mauritania","México","Micronesia","Moldavia","Mónaco","Mongolia","Montenegro","Mozambique","Namibia","Nauru","Nepal","Nicaragua","Níger","Nigeria","Noruega","Nueva Zelanda","Omán","Países Bajos","Pakistán","Palaos","Palestina","Panamá","Papúa Nueva Guinea","Paraguay","Perú","Polonia","Portugal","Reino Unido","República Centroafricana","República Checa","República de Macedonia","República del Congo","República Democrática del Congo","República Dominicana","República Sudafricana","Ruanda","Rumanía","Rusia","Samoa","San Cristóbal y Nieves","San Marino","San Vicente y las Granadinas","Santa Lucía","Santo Tomé y Príncipe","Senegal","Serbia","Seychelles","Sierra Leona","Singapur","Siria","Somalia","Sri Lanka","Suazilandia","Sudán","Sudán del Sur","Suecia","Suiza","Surinam","Tailandia","Tanzania","Tayikistán","Timor Oriental","Togo","Tonga","Trinidad y Tobago","Túnez","Turkmenistán","Turquía","Tuvalu","Ucrania","Uganda","Uruguay","Uzbekistán","Vanuatu","Venezuela","Vietnam","Yemen","Yibuti","Zambia","Zimbabue"];
  
  const defaultState = {
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
    data: {
      action: "contact-form"
    }
  };
  const [ formState, setFormState ] = useState(defaultState);

  const handleInputChange = event => {
    const target = event.target
    const value = target.value
    const name = target.name
    let state = formState;
    state[name] = value;
    setFormState(state);
  }
 
  const handleSubmit = event => {
    event.preventDefault();
    let requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formState),
      redirect: 'follow'
    };
    console.log(JSON.stringify(formState));

    fetch(`${process.env.GATSBY_WORDPRESS_URL}/wp-json/whiz-api/v1/lead`, requestOptions)
    .then(response => response.text())
    .then(result => console.log(result))
    .catch(error => console.log('error', error));
    setFormState(defaultState);
    thanksModal();
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-content">
        <h3 className="description">
        ¡Bríndanos tú información y nos contactaremos pronto!
        </h3>

        <div className="form-group">
          <label htmlFor="name" className="form-label">
            Nombre
          </label>
          <input
            onChange={handleInputChange}
            type="text"
            name="name"
            // value={formState.name}
            className="form-control"
            placeholder="Escribe tu nombre"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="name" className="form-label">
            Correo electrónico
          </label>
          <input
            onChange={handleInputChange}
            type="email"
            name="email"
            // value={formState.email}
            className="form-control"
            placeholder="Escribe tu correo electrónico"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="name" className="form-label">
            País
          </label>
          <select onChange={handleInputChange} className="form-select" defaultValue="" name="address" required>
            <option value="" disabled>
              Selecciona tu País
            </option>
            {countries.map((v, index) => (
              <option value={v} key={index}>
                {v}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="name" className="form-label">
            Teléfono
          </label>
          <input
            onChange={handleInputChange}
            type="text"
            name="phone"
            className="form-control"
            placeholder="Ej: +51 123 456 789 "
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="name" className="form-label">
            Mensaje
          </label>
          <textarea
            onChange={handleInputChange}
            className="form-control"
            name="message"
            placeholder="Escribe el mensaje"
            cols="30"
            rows="5"
            >
          </textarea>
        </div>

        <button className="btn btn--primary auto" type="submit">
          Enviar
        </button>
      </div>
    </form>
  );
};

export default Form;
